module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [(_vm.actionRequest.status == 200) ? _c('v-alert', {
    staticClass: "pa-2",
    attrs: {
      "value": true,
      "type": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n      Meeting information saved\n    ")]) : _vm._e(), _vm._v(" "), (_vm.actionRequest.status > 300) ? _c('server-errors', {
    attrs: {
      "request": _vm.actionRequest
    }
  }) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.actionRequest.result.meeting_url,
      "persistent-hint": "",
      "hint": "The url for your meeting",
      "label": "Meeting url"
    },
    model: {
      value: (_vm.appointment.zoom_join_url),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "zoom_join_url", $$v)
      },
      expression: "appointment.zoom_join_url"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "error-messages": _vm.actionRequest.result.zoom_meeting_password,
      "persistent-hint": "",
      "hint": "(optional) password for your meeting (if relevant)",
      "label": "Meeting password"
    },
    model: {
      value: (_vm.appointment.zoom_meeting_password),
      callback: function($$v) {
        _vm.$set(_vm.appointment, "zoom_meeting_password", $$v)
      },
      expression: "appointment.zoom_meeting_password"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.actionRequest.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-287e9aa9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Zoom/ManualOnlineMeetingForm.vue
// module id = 1365
// module chunks = 9